import React from 'react';
import './DataPolicy.scss';

const DataPolicy = () => {
  return (
    <div
    className="signup-content2 "
    style={{
      paddingLeft: "2%",
      paddingRight: "2%",
      paddingTop: "1%",
      height: "100vh",
    }}>
{/* <div
className="card  mb-3  p-2"
style={{
  background: "rgb(78 155 1 / 69%)",
  textAlign: "left",
}}
>
<h5 style={{ color: "whitesmoke", marginBottom: "0px" }}>
  {" "}
  Data Policy{" "}
</h5>
</div> */}


    <div className="data-policy-container">
      <h2 className="data-policy-title">311 Service – Data Policy</h2>
      <div className="data-policy-content">
        <p>
          We respect your privacy and are committed to protecting the personal data you provide through 311 services.
        </p>

        <h3>🔐 What We Collect</h3>
        <ul>
          <li>Contact information (e.g., name, phone, email)</li>
          <li>Service request details (location, type of issue)</li>
          <li>Optional feedback submitted by users</li>
        </ul>

        <h3>📦 How We Use Your Data</h3>
        <ul>
          <li>To respond to your service requests</li>
          <li>To improve city services based on trends and reports</li>
          <li>To notify you about updates on your case</li>
        </ul>

        <h3>🔒 Data Security</h3>
        <p>
          Your information is securely stored and only accessed by authorized personnel. We do not sell or share personal data with third parties unless legally required.
        </p>

        <h3>📅 Data Retention</h3>
        <p>
          Data related to service requests is kept for a limited period to support accountability and performance reviews.
        </p>

        <p className="disclaimer">
          For more information, contact <a href="mailto:privacy@city.gov">privacy@city.gov</a>.
        </p>
      </div>
    </div>
    </div>
  );
};

export default DataPolicy;
